import axios from '../utils/axios';

export const getCurrentConfig = async () => {
  const response = await axios.get('/api/User/GetCompanySetting');
  return response.data;
};

export const getSubscriptionPackage = async (invId) => {
  const response = await axios.get("/api/Package/GetList");
  return response.data;
};